import {type AnalyticsData, AnalyticsWrapper} from './analytics-wrapper';

declare const dataLayer: Array<unknown>;

export class GtmAnalyticsWrapper extends AnalyticsWrapper {
  /** The currently cached data before next GTM push. */
  private currentData: AnalyticsData = {};

  sendHit(
    type: string,
    data: AnalyticsData = {},
    timeout = 1000,
  ): Promise<void> {
    if (!type) {
      throw new Error('type must exist for sending hits.');
    }

    data['event'] = type;
    return this.push(data, timeout);
  }

  setField(fieldName: string, value: unknown): void {
    if (!fieldName) {
      throw new Error('fieldName must exist for sending hits.');
    }

    Object.assign(this.currentData, {[fieldName]: value});
  }

  push(data: AnalyticsData, timeout = 1000): Promise<void> {
    Object.assign(this.currentData, data);

    return new Promise<void>(resolve => {
      const dataToBePushed = this.currentData;
      this.currentData = {};

      let callbackTriggered = false;
      const callback = () => {
        if (!callbackTriggered) {
          callbackTriggered = true;
          resolve();
        }
      };

      dataToBePushed['eventCallback'] = callback;
      setTimeout(callback, timeout);

      if (typeof dataLayer !== 'undefined') {
        dataLayer.push(dataToBePushed);
      }
    });
  }
}
